<div *ngIf="isReady && kpiDates" class="dash-kpi">
  <table class="dash-kpi-list">
    <tr *ngFor="let s of stations">
      <td class="dash-kpi-list-name">{{ s.addonStationName }}</td>
      <td class="dash-kpi-list-value">{{ s.unitCount | number }}</td>
    </tr>
  </table>
  <div class="dash-kpi-label">Units that completed each Process Station</div>
  <div class="dash-kpi-caption">{{ totalUnitCount | number }} units in total. Each unit counts one time.</div>
  <div class="dash-kpi-caption">{{ rangeText }}</div>
</div>
<div *ngIf="isReady && !kpiDates" class="dash-kpi">
  <div class="dash-kpi-caption">Select a start date and an end date.</div>
</div>
<div *ngIf="!isReady" class="dash-kpi">
  <i class="pi pi-spin pi-spinner text-2xl"></i>
</div>
